import React from 'react';
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';

// TODO-BG: Need to use relative path as when `entities` is added
// to moduleNameMapper in jest config it breaks down storyshots
import { selectUser } from '../../entities/user/selectors';

const LandingPage = () => {
  const location = useLocation();
  const user = useSelector(selectUser);

  let redirectTo: null | string = null;

  if (
    user?.hasPrivilege(Privileges.ADVANCED_DASHBOARD_VIEW) &&
    user?.hasFeature(Features.ADVANCED_DASHBOARDS)
  ) {
    redirectTo = '/dashboards';
  } else if (
    user?.hasFeature(Features.BASIC_DASHBOARDS) &&
    user?.hasPrivilege(Privileges.DASHBOARD_VIEW)
  ) {
    redirectTo = '/stats';
  } else if (
    user?.hasFeature(Features.VOLUNTEERING) &&
    user?.hasPrivilege(Privileges.EVENT_MANAGE)
  ) {
    redirectTo = '/deeds/volunteer';
  } else if (
    user?.hasFeature(Features.EVENTS) &&
    user?.hasPrivilege(Privileges.BASE_EVENT_MANAGE)
  ) {
    redirectTo = '/deeds/events';
  } else if (
    user?.hasFeature(Features.VOLUNTEERING) &&
    user?.hasPrivilege(Privileges.PROJECT_MANAGE)
  ) {
    redirectTo = '/deeds/projects';
  } else if (
    user?.hasFeature(Features.VOLUNTEERING) &&
    user?.canDonate() &&
    user?.hasPrivilege(Privileges.FUNDRAISER_MANAGE)
  ) {
    redirectTo = '/deeds/campaigns';
  } else if (
    user?.hasFeature(Features.DONATIONS) &&
    user?.canDonate() &&
    user?.hasPrivilege(Privileges.DONATION_VIEW)
  ) {
    redirectTo = '/donations';
  } else if (
    user?.hasPrivilege(Privileges.FORM_MANAGE) &&
    user?.hasFeature(Features.VOLUNTEERING)
  ) {
    redirectTo = '/forms';
  } else if (user?.hasFeature(Features.SURVEYS) && user?.hasPrivilege(Privileges.SURVEY_MANAGE)) {
    redirectTo = '/surveys';
  } else if (user?.hasPrivilege(Privileges.PARTNER_VIEW)) {
    redirectTo = '/companies/partners/accepted';
  } else if (user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS)) {
    redirectTo = '/organization';
  } else if (
    user?.hasFeature(Features.VOLUNTEERING) &&
    user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_USERS)
  ) {
    redirectTo = '/volunteers';
  } else if (
    user?.hasPrivilege(Privileges.ORGANIZATION_SELF_VERIFY_OWNERSHIP) &&
    user?.privileges.length === 1
  ) {
    return <></>;
  }

  if (redirectTo) {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    if (code) {
      redirectTo = `${redirectTo}?code=${code}`;
    }
    return <Redirect to={redirectTo} />;
  }

  Sentry.captureMessage("LandingPage: Couldn't find a page to redirect the user.", {
    level: 'warning',
  });

  return <></>;
};

export default LandingPage;
